<template>
  <component v-if="getWrapper" :is="getWrapper" :service="service" />
  <component v-else-if="hasIcon(service.icon)" :is="service.icon" class="w-100" />
  <font-awesome-icon v-else icon="question-circle" size="4x" class="text-black-50" />
</template>

<script>
const SERVICE_ICON_COMPONENTS = [
  'Heat', 'Light', 'SunBlind', 'ElMeter', 'SwitchSingle', 'Regulator', 'WeatherMeter',
  'SwitchDouble', 'MultiswitchSingle', 'MultiswitchDouble', 'FVEInverter', 'Weather', 'Energy',
  'Mode', 'System', 'CO2Meter', 'CoolingDevice', 'DimmLight', 'FVEPowerStation',
  'GeneralElectricalDevice', 'HeatDevice', 'HumidityMeter', 'Irrigation',
  'IrrigationCircuit', 'LightDALI', 'Pond', 'PressureMeter', 'RGBLight',
  'SwimmingPool', 'ThermoHumidityMeter', 'Thermometer', 'TimeUpdate',
  'UnderfloorHeating', 'UVLamp', 'Ventilator', 'WaterLevelMeasurement',
  'WaterMeasuring', 'WaterMeter', 'WaterPumping', 'WaterSoftener',
  'WaterSupply', 'WaterTreatment', 'AlarmDetector', 'AlarmOutput', 'AlarmZone', 'Communication',
  'Jablotron', 'Security', 'Gate',
  'GateDevice',
  'HeatingPumpControl',
  'Fireplace',
  'HeatingTank',
  'DoorDevice',
  'Door',
  'Device',
  'HeatingPump',
  'Input',
  'MixingValve',
  'Pir',
  'RainDetector',
  'SwimmingPoolCleaner',
  'SwimmingPoolFiltration',
  'SwimmingPoolJet',
  'TemperatureLight',
  'TouchGlass',
  'WaterJetPump',
  'WaterPump',
  'WeatherStation',
];

const ServiceWrapperIconMapping = {
  Light: 'LightWrapper',
  Heat: 'HeatWrapper',
  HeatDevice: 'HeatDeviceWrapper',
  UnderfloorHeating: 'UnderfloorHeatingWrapper',
  CoolingDevice: 'CoolingDeviceWrapper',
};

export default {
  name: 'ServiceIconWrapper',
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getWrapper() {
      return ServiceWrapperIconMapping[this.service.icon];
    },
  },
  methods: {
    hasIcon(icon) {
      return this.$_.includes(SERVICE_ICON_COMPONENTS, icon);
    },
  },
};
</script>

<style scoped>

</style>
